(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["halue-size-guide-link"] && !Shopify.designMode) return;
  try {
    const SIZE_GUIDE_DRAWER_ID = 'tspec-size-drawer';
  const SIZE_GUIDE_TRIGGER = '.halue-size-guide-link__button';

  // The button ships hidden so that a page without the Tech Specs section never shows a
  // control that cannot do anything. It is revealed only once the drawer is known to exist.
  function revealSizeGuideTriggers() {
    if (!document.getElementById(SIZE_GUIDE_DRAWER_ID)) return;
    document.querySelectorAll(SIZE_GUIDE_TRIGGER).forEach(function (button) {
      button.hidden = false;
    });
  }

  function handleSizeGuideClick(event) {
    const trigger = event.target.closest(SIZE_GUIDE_TRIGGER);
    if (!trigger) return;
    if (typeof window.tspecOpenSizeGuide === 'function') {
      window.tspecOpenSizeGuide();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', revealSizeGuideTriggers);
  } else {
    revealSizeGuideTriggers();
  }

  // Section rendering replaces markup in place, so re-check after the theme swaps a section.
  document.addEventListener('shopify:section:load', revealSizeGuideTriggers);
  document.addEventListener('click', handleSizeGuideClick);
  } catch(e) { console.error(e); }
})();

})();
